// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'shop_item_bundle',
    label: '',
    Object: 'value',
    width: '180'
  }]
}
